import styles from "./company.module.css";

import { NavLink } from "react-router-dom";
function Company() {
  return (
    <div className={styles.main}>
      <div className={styles.box}>
        <img
          src="https://cdn.prod.website-files.com/5e67e8a5114126293a525bd7/5f6e2d75d3695d79a0111508_KPOP_TITLE.gif"
          alt=""
          className={styles.gif}
        />
        <NavLink to="/company" style={{ textDecoration: "none" }}>
          <h1 className={styles.title}>
            Learn The K-Pop Dance Covers with Lily
          </h1>
        </NavLink>
      </div>
    </div>
  );
}

export default Company;
/*<div
        className={styles.boxt}
        style={{ backgroundImage: `url(${one})` }}
      ></div>*/
